import { createAction } from '@reduxjs/toolkit';
import * as types from './types';

export default {
  setOrgs: createAction(types.SET_ORG_LIST),
};
